(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gear-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('toggle',event=>{
    const active=event.target;
    if(!active.matches('.gear-guide-point[open]'))return;
    active.closest('.gear-guide-hotspot').querySelectorAll('.gear-guide-point[open]').forEach(point=>{if(point!==active)point.removeAttribute('open')});
  },true);
  document.addEventListener('click',event=>{
    const close=event.target.closest('[data-guide-close]');
    if(close)close.closest('.gear-guide-point').removeAttribute('open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bns-intro-video')) customElements.define('bns-intro-video', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        const video = this.querySelector('video'), button = this.querySelector('button');
        if (!video || !button) return;
        this.events = new AbortController();
        const options = {signal:this.events.signal};
        const sync = () => {button.setAttribute('aria-label',video.paused ? button.dataset.playLabel : button.dataset.pauseLabel);button.querySelector('[data-pause-icon]').hidden=video.paused;button.querySelector('[data-play-icon]').hidden=!video.paused;};
        video.muted = true;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) {video.autoplay=false;video.pause();}
        button.hidden = false;
        button.addEventListener('click', () => {if(video.paused) video.play().catch(sync); else video.pause();}, options);
        video.addEventListener('play',sync,options);video.addEventListener('pause',sync,options);sync();
      });
    }
    disconnectedCallback() {cancelAnimationFrame(this.frame);this.events?.abort();}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopee-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initReviews = (root) => {
      if (!root || root.dataset.reviewsReady === 'true') return;
      root.dataset.reviewsReady = 'true';
      const cards = Array.from(root.querySelectorAll('[data-review-card]'));
      const filters = Array.from(root.querySelectorAll('[data-review-filter]'));
      const empty = root.querySelector('[data-review-empty]');
      filters.forEach((button) => {
        const category = button.dataset.reviewFilter;
        if (category !== 'all' && !cards.some((card) => card.dataset.category === category)) button.hidden = true;
        button.addEventListener('click', () => {
          filters.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          let visible = 0;
          cards.forEach((card) => {
            const show = category === 'all' || card.dataset.category === category;
            card.hidden = !show;
            if (show) visible += 1;
          });
          if (empty) empty.hidden = visible !== 0;
        });
      });
    };
    const start = () => document.querySelectorAll('[data-bns-reviews]').forEach(initReviews);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-bns-reviews]');
      if (root) initReviews(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
